import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import SEO from '../../common/SEO';
import GoogleMaps from '../../components/GoogleMaps';
import ServicesNavigationFooter from '../../components/ServicesNavigationFooter';
import RelatedTopics from '../../components/RelatedTopics';
import MortgageCalculator from '../../components/MortgageCalculator'; // IMPORT
import * as FiIcons from 'react-icons/fi';

// Icons erweitert um MapPin,Mail,Phone
const {FiArrowLeft,FiCheckCircle,FiShield,FiDollarSign,FiHome,FiInfo,FiTrendingUp,FiFileText,FiHelpCircle,FiExternalLink,FiMapPin,FiMail,FiPhone}=FiIcons;

function FundingNRW() {
  const articleSchema={
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Article",
        "headline": "Förderprogramme für Hausbesitzer in NRW: Über 50 Förderungen für Sanierung,Renovierung und Modernisierung (2026 Guide)",
        "alternativeHeadline": "Förderprogramme für Hausbesitzer in NRW 2026",
        "image": "https://mx.ausbau.nrw/img/Daemmtechnik_xl.jpg",
        "author": {
          "@type": "Person",
          "name": "Maxim Kelm",
          "jobTitle": "Geschäftsführer MK-AUSBAU",
          "url": "https://ausbau.nrw/ueber"
        },
        "publisher": {
          "@type": "Organization",
          "name": "MK-AUSBAU",
          "logo": {
            "@type": "ImageObject",
            "url": "https://ausbau.nrw/logo-icon.svg"
          }
        },
        "datePublished": "2026-06-01",
        "description": "Bis zu 70% Zuschuss für Ihre Sanierung in NRW! 💰 Übersicht aller Förderprogramme 2026: NRW.BANK,KfW,BAFA. Für Heizung,Fenster,Dach & Dämmung.",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://ausbau.nrw/blog/foerderprogramme-hausbesitzer-nrw-2026"
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Welche Förderprogramme gibt es für Hausbesitzer in NRW?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Hausbesitzer in Nordrhein-Westfalen können Förderprogramme vom Land NRW,von der NRW.BANK,von der KfW,vom BAFA und aus Bundesprogrammen nutzen. Gefördert werden unter anderem Sanierungen,Modernisierungen,Heizungen,Dämmung,Fenster,barrierefreier Umbau,Wohneigentum und klimafreundlicher Neubau."
            }
          },
          {
            "@type": "Question",
            "name": "Lohnt sich eine Förderung für private Hausbesitzer überhaupt?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ja. Gerade private Eigentümer lassen häufig Fördermittel ungenutzt. Je nach Maßnahme können Zuschüsse,zinsgünstige Kredite oder Tilgungsnachlässe die Gesamtkosten deutlich senken."
            }
          },
          {
            "@type": "Question",
            "name": "Wie hoch kann eine Förderung in NRW ausfallen?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Die Förderhöhe hängt vom jeweiligen Programm ab. Möglich sind Zuschüsse von bis zu 70 Prozent bei einzelnen Maßnahmen oder Förderdarlehen von deutlich über 100.000 Euro bei größeren Projekten."
            }
          },
          {
            "@type": "Question",
            "name": "Welche Maßnahmen werden besonders häufig gefördert?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Besonders häufig gefördert werden energetische Sanierungen,Heizungstausch,Dämmung,neue Fenster,barrierereduzierende Umbauten,Dachsanierungen,Fassadensanierungen sowie nachhaltige Neubauten."
            }
          },
          {
            "@type": "Question",
            "name": "Gibt es Förderungen für Altbauten in NRW?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ja. Für ältere Bestandsgebäude gibt es zahlreiche passende Programme,etwa für energetische Sanierung,Modernisierung,Wohnwertverbesserung oder den barrierefreien Umbau."
            }
          },
          {
            "@type": "Question",
            "name": "Kann ich mehrere Förderprogramme gleichzeitig nutzen?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "In vielen Fällen ja. Häufig werden Landesförderungen,Programme der NRW.BANK und Bundesförderungen miteinander kombiniert. Welche Kombination möglich ist,hängt von der jeweiligen Maßnahme und den Förderbedingungen ab."
            }
          },
          {
            "@type": "Question",
            "name": "Muss der Förderantrag vor Beginn der Arbeiten gestellt werden?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "In sehr vielen Fällen ja. Förderanträge müssen oft vor dem Start der Bau- oder Sanierungsmaßnahme gestellt und bewilligt werden. Wer zu früh beginnt,riskiert den Verlust der Förderung."
            }
          },
          {
            "@type": "Question",
            "name": "Gibt es Förderungen für eine neue Heizung?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ja. Für den Austausch alter Heizsysteme oder den Einbau effizienter Heiztechnik gibt es je nach Programm Zuschüsse oder ergänzende Kredite,besonders im Rahmen energetischer Sanierungen."
            }
          },
          {
            "@type": "Question",
            "name": "Werden auch Fenster,Dämmung und Dachsanierung gefördert?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ja. Fenster,Dämmung und Dachsanierung gehören zu den klassischen förderfähigen Sanierungsmaßnahmen,weil sie die Energieeffizienz eines Hauses deutlich verbessern können."
            }
          },
          {
            "@type": "Question",
            "name": "Gibt es Förderungen für barrierefreies Wohnen?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ja. Förderfähig sind häufig Maßnahmen wie bodengleiche Duschen,breitere Türen,Rampen,Treppenhilfen oder der altersgerechte Umbau von Wohnraum."
            }
          },
          {
            "@type": "Question",
            "name": "Gibt es Förderungen für den Hauskauf in NRW?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ja. Neben Sanierungsförderungen gibt es auch Programme für den Bau oder Kauf von selbstgenutztem Wohneigentum,vor allem für bestimmte Zielgruppen und Einkommensbereiche."
            }
          },
          {
            "@type": "Question",
            "name": "Sind Förderprogramme nur für große Investoren gedacht?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Nein. Viele Förderprogramme richten sich ausdrücklich an Privatpersonen,Familien und Eigentümer selbst genutzter Immobilien. Gerade in diesem Bereich wird Förderung oft zu selten genutzt."
            }
          },
          {
            "@type": "Question",
            "name": "Wo finde ich die offiziellen Förderprogramme?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Die wichtigsten offiziellen Quellen sind die Förderdatenbank des Bundes,die NRW.BANK,die KfW und das BAFA. In einem guten Überblick sollten die Programme direkt verlinkt sein,damit Eigentümer nicht selbst lange suchen müssen."
            }
          },
          {
            "@type": "Question",
            "name": "Was ist besser: Zuschuss oder Förderkredit?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Das lässt sich nicht pauschal sagen. Zuschüsse senken direkte Kosten,Förderkredite verbessern häufig die Finanzierung. In vielen Fällen ist eine Kombination besonders interessant."
            }
          },
          {
            "@type": "Question",
            "name": "Wann lohnt sich eine professionelle Beratung?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Eine professionelle Beratung lohnt sich besonders dann,wenn mehrere Maßnahmen geplant sind,etwa Heizung,Fenster,Dämmung und Innenausbau zusammen. Dann sollten Fördermöglichkeiten frühzeitig in die Projektplanung einbezogen werden."
            }
          },
          {
            "@type": "Question",
            "name": "Unterstützt MK-AUSBAU auch bei der praktischen Umsetzung?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ja. Wer Modernisierung,Renovierung oder Innenausbau in NRW plant,findet auf https://ausbau.nrw weitere Informationen zu Leistungen,Projekten und Kontaktmöglichkeiten."
            }
          }
        ]
      }
    ]
  };

  const fadeIn={initial: {opacity: 0,y: 20},animate: {opacity: 1,y: 0},transition: {duration: 0.6}};

  return (
    <div className="py-20 bg-white">
      <SEO 
        title="Förderprogramme NRW 2026: Sanierung & Renovierung Guide" 
        description="Fördermittel für Hausbesitzer in NRW sichern! 💰 Bis zu 70% Zuschuss für Dämmung,Fenster,Heizung & Umbau. Der komplette Guide 2026." 
        keywords="Förderprogramme NRW 2026,NRW.BANK Sanierung,KfW Förderung Heizung,BAFA Zuschuss Fenster,Altbausanierung Förderung NRW" 
        schema={articleSchema} 
        canonical="/blog/foerderprogramme-hausbesitzer-nrw-2026" 
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
        <Link to="/blog" className="inline-flex items-center text-mk-teal-600 hover:text-mk-teal-700 font-bold mb-8 transition-colors group" >
          <SafeIcon icon={FiArrowLeft} className="mr-2 w-5 h-5 group-hover:-translate-x-1 transition-transform" />
          Zurück zur Übersicht
        </Link>
        <motion.article {...fadeIn} className="prose prose-lg prose-mk max-w-none">
          {/* Header */}
          <header className="mb-12">
            <div className="flex items-center space-x-3 text-mk-teal-600 font-bold uppercase tracking-wider text-sm mb-4 text-left">
              <SafeIcon icon={FiDollarSign} />
              <span>Finanzen & Förderung</span>
            </div>
            <h1 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight mb-6 text-left">
              Förderprogramme für Hausbesitzer in NRW: Über 50 Förderungen für Sanierung,Renovierung und Modernisierung (2026 Guide)
            </h1>
            <div className="flex items-center space-x-4 text-gray-500 text-sm border-y border-gray-100 py-4">
              <span className="flex items-center"><SafeIcon icon={FiShield} className="mr-1" /> Experten-Ratgeber</span>
              <span className="flex items-center"><SafeIcon icon={FiInfo} className="mr-1" /> Stand: Juni 2026</span>
            </div>
          </header>
          
          {/* Intro Text */}
          <div className="lead text-xl text-gray-600 leading-relaxed mb-12 text-left">
            Viele Hausbesitzer investieren jedes Jahr enorme Summen in Renovierungen oder Modernisierungen. Neue Fenster,eine moderne Heizung,eine Wärmepumpe oder eine komplette Haussanierung können schnell 20.000 bis über 150.000 Euro kosten.
          </div>
          
          <p className="text-gray-700">
            Was viele Eigentümer jedoch nicht wissen: In Nordrhein-Westfalen existieren zahlreiche staatliche Förderprogramme,die genau solche Maßnahmen unterstützen. Trotzdem beschäftigen sich erstaunlich wenige private Hausbesitzer mit diesen Möglichkeiten.
          </p>

          <div className="bg-mk-teal-50 border-l-4 border-mk-teal-500 p-6 rounded-r-xl my-8">
            <h3 className="text-mk-teal-900 font-bold m-0 text-lg mb-2">Warum Geld verschenken?</h3>
            <p className="text-gray-700 m-0">
              In Wirklichkeit können Förderprogramme finanzielle Vorteile von <strong>50.000 € bis über 200.000 €</strong> bringen – durch Zuschüsse,Tilgungszuschüsse oder zinsgünstige Kredite.
            </p>
          </div>

          <p className="text-gray-700">
            Als Renovierungs- und Ausbauunternehmen erlebt <Link to="/" className="text-mk-teal-600 font-bold hover:underline">MK-AUSBAU</Link> regelmäßig,dass Hausbesitzer erst während der Planung oder sogar erst während der Bauphase erfahren,dass sie eigentlich Anspruch auf Fördergelder gehabt hätten. Dieser Artikel zeigt deshalb eine umfassende Übersicht der wichtigsten Förderprogramme für Hausbesitzer in NRW.
          </p>

          {/* Warum wichtig */}
          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6">Warum Förderprogramme für Haussanierungen so wichtig sind</h2>
          <p className="text-gray-700 mb-6">
            Die Kosten für Bau- und Renovierungsarbeiten sind in den letzten Jahren deutlich gestiegen. Hier eine Übersicht typischer Kosten:
          </p>

          <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm mb-12">
            <table className="min-w-full text-sm text-left">
              <thead className="bg-mk-teal-600 text-white">
                <tr>
                  <th className="px-6 py-4">Maßnahme</th>
                  <th className="px-6 py-4">Durchschnittskosten</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                <tr><td className="px-6 py-4 font-medium">Dachsanierung</td><td className="px-6 py-4">30.000 – 70.000 €</td></tr>
                <tr><td className="px-6 py-4 font-medium">Heizung erneuern</td><td className="px-6 py-4">15.000 – 40.000 €</td></tr>
                <tr><td className="px-6 py-4 font-medium">Fassadendämmung</td><td className="px-6 py-4">20.000 – 60.000 €</td></tr>
                <tr><td className="px-6 py-4 font-medium">Fenster erneuern</td><td className="px-6 py-4">10.000 – 25.000 €</td></tr>
                <tr className="bg-gray-50"><td className="px-6 py-4 font-bold text-mk-teal-900">Komplettsanierung</td><td className="px-6 py-4 font-bold text-mk-teal-900">80.000 – 200.000 €</td></tr>
              </tbody>
            </table>
          </div>

          <p className="text-gray-700 mb-12">
            Durch Förderprogramme lassen sich diese Kosten häufig erheblich reduzieren. Je nach Programm können Hausbesitzer <strong>bis zu 70 % Zuschuss</strong> erhalten oder <strong>zinsgünstige Kredite über 200.000 €</strong> nutzen.
          </p>

          {/* Die wichtigsten Programme */}
          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6">Die wichtigsten Förderprogramme für Hausbesitzer in NRW</h2>
          
          <div className="space-y-8 mb-12">
            {/* Öffentliche Wohnraumförderung */}
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                <SafeIcon icon={FiHome} className="text-mk-teal-500 mr-2" />
                Öffentliche Wohnraumförderung NRW – Modernisierung
              </h3>
              <ul className="space-y-2 mb-4 text-gray-700">
                <li className="flex items-center"><SafeIcon icon={FiCheckCircle} className="text-green-500 mr-2"/> Energetische Sanierung</li>
                <li className="flex items-center"><SafeIcon icon={FiCheckCircle} className="text-green-500 mr-2"/> Barrierefreier Umbau</li>
                <li className="flex items-center"><SafeIcon icon={FiCheckCircle} className="text-green-500 mr-2"/> Verbesserung der Wohnqualität</li>
              </ul>
              <div className="bg-gray-50 p-4 rounded-lg mb-4">
                <span className="block text-xs text-gray-500 uppercase font-bold">Förderhöhe</span>
                <span className="text-lg font-bold text-mk-teal-700">bis zu 220.000 € Darlehen pro Wohnung/Eigenheim</span>
              </div>
              <a href="https://www.foerderdatenbank.de/FDB/Content/DE/Foerderprogramm/Land/NRW/oeffentliche-wohnraumfoerderung-modernisierung.html" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-mk-teal-600 font-bold hover:underline">
                Zum Programm <SafeIcon icon={FiExternalLink} className="ml-2 w-4 h-4"/>
              </a>
            </div>

            {/* Lokaler Experten-Tipp Heinsberg */}
            <div className="bg-mk-teal-50 border border-mk-teal-200 rounded-xl p-6 shadow-sm relative overflow-hidden">
              <div className="absolute top-0 right-0 p-4 opacity-10">
                <SafeIcon icon={FiMapPin} className="w-24 h-24 text-mk-teal-600" />
              </div>
              <h4 className="text-lg font-bold text-mk-teal-900 mb-4 flex items-center relative z-10">
                <SafeIcon icon={FiMapPin} className="mr-2 text-mk-teal-600" />
                Experten-Tipp: Ansprechpartner im Kreis Heinsberg
              </h4>
              <p className="text-sm text-mk-teal-800 mb-6 relative z-10 max-w-2xl">
                Für Bauherren in Heinsberg,Geilenkirchen,Erkelenz & Umgebung: Die Bewilligungsbehörde für öffentliche Mittel ist direkt beim Kreis angesiedelt. Hier die direkten Durchwahlen:
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative z-10 text-sm">
                <div>
                  <strong className="block text-mk-teal-900 mb-2 border-b border-mk-teal-200 pb-1">Amt für Bauen und Wohnen</strong>
                  <address className="not-italic text-mk-teal-800 mb-4">
                    Kreis Heinsberg<br/>
                    Valkenburger Str. 45<br/>
                    52525 Heinsberg
                  </address>
                  <a href="mailto:wohnraumfoerderung@kreis-heinsberg.de" className="inline-flex items-center text-mk-teal-700 font-bold hover:underline">
                    <SafeIcon icon={FiMail} className="mr-2 w-4 h-4"/>
                    wohnraumfoerderung@kreis-heinsberg.de
                  </a>
                </div>
                
                <div>
                  <strong className="block text-mk-teal-900 mb-2 border-b border-mk-teal-200 pb-1">Ihre Ansprechpartner</strong>
                  <div className="space-y-3 text-mk-teal-800">
                    <div>
                      <span className="block text-xs font-bold uppercase tracking-wider text-mk-teal-600">Eigentum & Modernisierung</span>
                      <div className="flex flex-col">
                        <span className="flex items-center justify-between"><span>Stefanie Somers</span> <a href="tel:02452136346" className="font-mono font-bold hover:text-mk-teal-600">02452 13-6346</a></span>
                        <span className="flex items-center justify-between"><span>Erik Wynands</span> <a href="tel:02452136337" className="font-mono font-bold hover:text-mk-teal-600">02452 13-6337</a></span>
                      </div>
                    </div>
                    <div>
                      <span className="block text-xs font-bold uppercase tracking-wider text-mk-teal-600">Mietwohnraum</span>
                      <div className="flex flex-col">
                        <span className="flex items-center justify-between"><span>Willi Coenen</span> <a href="tel:02452136332" className="font-mono font-bold hover:text-mk-teal-600">02452 13-6332</a></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* NRW.BANK.Gebäudesanierung */}
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                <SafeIcon icon={FiTrendingUp} className="text-mk-teal-500 mr-2" />
                NRW.BANK.Gebäudesanierung
              </h3>
              <ul className="space-y-2 mb-4 text-gray-700">
                <li className="flex items-center"><SafeIcon icon={FiCheckCircle} className="text-green-500 mr-2"/> Dach- & Fassadensanierung</li>
                <li className="flex items-center"><SafeIcon icon={FiCheckCircle} className="text-green-500 mr-2"/> Heizungsmodernisierung</li>
                <li className="flex items-center"><SafeIcon icon={FiCheckCircle} className="text-green-500 mr-2"/> Barrierefreier Umbau</li>
              </ul>
              <div className="bg-gray-50 p-4 rounded-lg mb-4">
                <span className="block text-xs text-gray-500 uppercase font-bold">Förderung</span>
                <span className="text-lg font-bold text-mk-teal-700">bis zu 150.000 € Kredit</span>
              </div>
              <a href="https://www.nrwbank.de/de/foerderung/foerderprodukte/15603/nrwbank-gebaeudesanierung.html" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-mk-teal-600 font-bold hover:underline mb-6">
                Zum Programm <SafeIcon icon={FiExternalLink} className="ml-2 w-4 h-4"/>
              </a>

              {/* INTEGRATION TILGUNGSRECHNER */}
              <div className="mt-8 border-t border-gray-200 pt-8">
                <h4 className="font-bold text-gray-900 mb-4">Finanzierung simulieren:</h4>
                <p className="text-sm text-gray-600 mb-6">
                  Nutzen Sie unseren Rechner,um Ihre monatliche Belastung bei einem Förderkredit der NRW.BANK unverbindlich zu berechnen.
                </p>
                <MortgageCalculator />
              </div>
            </div>

            {/* BEG */}
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                <SafeIcon icon={FiShield} className="text-mk-teal-500 mr-2" />
                Bundesförderung für effiziente Gebäude (BEG)
              </h3>
              <ul className="space-y-2 mb-4 text-gray-700">
                <li className="flex items-center"><SafeIcon icon={FiCheckCircle} className="text-green-500 mr-2"/> Dämmung & Fenster</li>
                <li className="flex items-center"><SafeIcon icon={FiCheckCircle} className="text-green-500 mr-2"/> Wärmepumpen & Heizung</li>
                <li className="flex items-center"><SafeIcon icon={FiCheckCircle} className="text-green-500 mr-2"/> Energetische Sanierungen</li>
              </ul>
              <div className="bg-gray-50 p-4 rounded-lg mb-4">
                <span className="block text-xs text-gray-500 uppercase font-bold">Zuschuss</span>
                <span className="text-lg font-bold text-green-600">bis zu 70 % möglich</span>
              </div>
              <a href="https://www.foerderdatenbank.de/FDB/Content/DE/Foerderprogramm/Bund/BMWK/bundesfoerderung-effiziente-gebaeude.html" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-mk-teal-600 font-bold hover:underline">
                Zum Programm <SafeIcon icon={FiExternalLink} className="ml-2 w-4 h-4"/>
              </a>
            </div>
          </div>

          {/* Tabelle NRW.BANK */}
          <h3 className="text-2xl font-bold text-gray-900 mb-6">Förderprogramme der NRW.BANK im Überblick</h3>
          <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm mb-12">
            <table className="min-w-full text-sm text-left bg-white">
              <thead className="bg-gray-100 text-gray-900">
                <tr>
                  <th className="px-6 py-4">Programm</th>
                  <th className="px-6 py-4">Art</th>
                  <th className="px-6 py-4">Link</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr><td className="px-6 py-4 font-medium">Gebäudesanierung</td><td className="px-6 py-4">Kredit</td><td className="px-6 py-4"><a href="https://www.nrwbank.de/de/foerderung/foerderprodukte/15603/nrwbank-gebaeudesanierung.html" className="text-mk-teal-600 hover:underline">Details</a></td></tr>
                <tr><td className="px-6 py-4 font-medium">Wohneigentum</td><td className="px-6 py-4">Kredit</td><td className="px-6 py-4"><a href="https://www.foerderdatenbank.de/FDB/Content/DE/Foerderprogramm/Land/NRW/nrw-bank-wohneigentum-.html" className="text-mk-teal-600 hover:underline">Details</a></td></tr>
                <tr><td className="px-6 py-4 font-medium">Nachhaltig Wohnen</td><td className="px-6 py-4">Kredit</td><td className="px-6 py-4"><a href="https://www.nrwbank.de/de/foerderung/foerderprodukte/60050/nrwbank-nachhaltig-wohnen.html" className="text-mk-teal-600 hover:underline">Details</a></td></tr>
                <tr><td className="px-6 py-4 font-medium">Wohnraum Studierende</td><td className="px-6 py-4">Kredit</td><td className="px-6 py-4"><a href="https://www.nrwbank.de/de/foerderung/foerderprodukte/16004" className="text-mk-teal-600 hover:underline">Details</a></td></tr>
                <tr><td className="px-6 py-4 font-medium">Menschen mit Behinderung</td><td className="px-6 py-4">Kredit</td><td className="px-6 py-4"><a href="https://www.nrwbank.de/de/foerderung/foerderprodukte/60235" className="text-mk-teal-600 hover:underline">Details</a></td></tr>
              </tbody>
            </table>
          </div>

          {/* Tabelle Bundesförderungen */}
          <h3 className="text-2xl font-bold text-gray-900 mb-6">Bundesförderungen für Hausbesitzer</h3>
          <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm mb-12">
            <table className="min-w-full text-sm text-left bg-white">
              <thead className="bg-gray-100 text-gray-900">
                <tr>
                  <th className="px-6 py-4">Programm</th>
                  <th className="px-6 py-4">Art</th>
                  <th className="px-6 py-4">Anbieter</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr><td className="px-6 py-4 font-medium">BEG Einzelmaßnahmen</td><td className="px-6 py-4 text-green-600 font-bold">Zuschuss</td><td className="px-6 py-4">BAFA / KfW</td></tr>
                <tr><td className="px-6 py-4 font-medium">Heizungsförderung</td><td className="px-6 py-4 text-green-600 font-bold">Zuschuss</td><td className="px-6 py-4">KfW (458)</td></tr>
                <tr><td className="px-6 py-4 font-medium">Energieberatung</td><td className="px-6 py-4 text-green-600 font-bold">Zuschuss</td><td className="px-6 py-4">BAFA</td></tr>
                <tr><td className="px-6 py-4 font-medium">Wohngebäude 261</td><td className="px-6 py-4">Kredit + Tilgungszuschuss</td><td className="px-6 py-4">KfW</td></tr>
                <tr><td className="px-6 py-4 font-medium">Altersgerecht Umbauen</td><td className="px-6 py-4">Kredit</td><td className="px-6 py-4">KfW (159)</td></tr>
                <tr><td className="px-6 py-4 font-medium">Klimafreundl. Neubau</td><td className="px-6 py-4">Kredit</td><td className="px-6 py-4">KfW (297/298)</td></tr>
              </tbody>
            </table>
          </div>

          <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 mb-12">
            <h4 className="font-bold text-gray-900 mb-2">Weitere Programme finden</h4>
            <p className="text-gray-700 text-sm mb-4">
              Zusätzlich existieren zahlreiche weitere Förderprogramme (z.B. Denkmalschutz,Quartiersentwicklung). Eine vollständige Übersicht finden Sie in der Förderdatenbank des Bundes.
            </p>
            <a href="https://www.foerderdatenbank.de" target="_blank" rel="noopener noreferrer" className="text-mk-teal-600 font-bold hover:underline">
              Zur Förderdatenbank →
            </a>
          </div>

          {/* FAQ Section */}
          <div className="mt-20 pt-12 border-t border-gray-200">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Häufige Fragen zu Förderprogrammen (FAQ)
            </h2>
            <div className="space-y-4">
              {[
                {q: "Welche Förderprogramme gibt es für Hausbesitzer in NRW?",a: "In Nordrhein-Westfalen gibt es Förderprogramme vom Land NRW,von der NRW.BANK,von der KfW,vom BAFA und aus Bundesprogrammen. Gefördert werden unter anderem Sanierungen,Modernisierungen,Heizungen,Dämmung,Fenster,barrierefreier Umbau,Wohneigentum und klimafreundlicher Neubau."},
                {q: "Lohnt sich eine Förderung für private Hausbesitzer überhaupt?",a: "Ja. Gerade private Eigentümer lassen oft viel Geld liegen,weil sie Förderprogramme nicht prüfen. Je nach Maßnahme können Zuschüsse,zinsgünstige Kredite oder Tilgungsnachlässe die Gesamtkosten deutlich senken."},
                {q: "Wie hoch kann eine Förderung in NRW ausfallen?",a: "Das hängt vom Programm ab. Manche Programme fördern mit Zuschüssen von bis zu 70 Prozent einzelner Maßnahmen,andere mit Darlehen von deutlich über 100.000 Euro. Bei größeren Projekten kann der finanzielle Vorteil schnell mehrere zehntausend Euro betragen."},
                {q: "Muss der Antrag vor Beginn der Arbeiten gestellt werden?",a: "In sehr vielen Fällen ja. Förderanträge müssen oft vor dem Start der Bau- oder Sanierungsmaßnahme gestellt und bewilligt werden. Wer zu früh beginnt,riskiert den Verlust der Förderung."},
                {q: "Gibt es Förderungen für Altbauten in NRW?",a: "Ja. Gerade für ältere Bestandsgebäude gibt es viele passende Programme,zum Beispiel für energetische Sanierung,Modernisierung,Wohnwertverbesserung oder den barrierefreien Umbau."},
                {q: "Kann ich mehrere Förderprogramme gleichzeitig nutzen?",a: "In vielen Fällen ja. Häufig werden Landesförderungen,Programme der NRW.BANK und Bundesförderungen kombiniert. Welche Kombination möglich ist,hängt von der Maßnahme und den jeweiligen Förderbedingungen ab."},
                {q: "Wo finde ich die offiziellen Förderprogramme?",a: "Die wichtigsten offiziellen Quellen sind die Förderdatenbank des Bundes,die NRW.BANK,die KfW und das BAFA. In einem guten Überblick sollten die Programme direkt verlinkt sein,damit Eigentümer nicht selbst lange suchen müssen."},
                {q: "Wann lohnt sich eine professionelle Beratung?",a: "Spätestens dann,wenn mehrere Maßnahmen geplant sind,etwa Heizung,Fenster,Dämmung und Innenausbau zusammen. Dann ist es sinnvoll,Fördermöglichkeiten frühzeitig mit der Projektplanung zu verbinden."},
                {q: "Unterstützt MK-AUSBAU auch bei der praktischen Umsetzung?",a: "Ja. Wer Modernisierung,Renovierung oder Innenausbau in NRW plant,findet bei uns professionelle Unterstützung für Trockenbau,Dämmung,Boden und mehr."}
              ].map((faq,index)=> (
                <div key={index} className="bg-gray-50 rounded-xl p-6 hover:bg-mk-teal-50 transition-colors cursor-default">
                  <h3 className="font-bold text-gray-900 mb-2 flex items-start">
                    <SafeIcon icon={FiHelpCircle} className="text-mk-teal-500 mt-1 mr-3 flex-shrink-0" />
                    {faq.q}
                  </h3>
                  <p className="text-gray-700 text-sm ml-8 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="text-center py-12 mt-12 border-t border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Planen Sie eine Sanierung in NRW?</h3>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Nutzen Sie die verfügbaren Förderungen und setzen Sie Ihr Projekt mit einem erfahrenen Partner um. Wir unterstützen Sie bei Renovierung,Innenausbau und energetischer Sanierung.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/kontakt" className="bg-mk-teal-500 hover:bg-mk-teal-600 text-white px-8 py-4 rounded-sm font-bold transition-all shadow-lg flex items-center justify-center" >
                Projekt anfragen
              </Link>
              <Link to="/services" className="bg-mk-red-700 hover:bg-mk-red-800 text-white px-8 py-4 rounded-sm font-bold transition-all shadow-lg flex items-center justify-center" >
                Unsere Leistungen
              </Link>
            </div>
          </div>
        </motion.article>
      </div>
      <RelatedTopics />
      <ServicesNavigationFooter />
      <GoogleMaps />
    </div>
  );
}

export default FundingNRW;